import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from './base.service';
import { SharedService } from './sharedService';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
 
export class AdminService extends BaseService{

  constructor(public http: HttpClient, public sharedService: SharedService) { 
    super(http, sharedService);
  }

  getAdmin(): Observable<any> {
    return this.http.get(this.sharedService.apiUrl('admin')).pipe(
      map(res => {
        return res;
      })
    );
  }
  getSmsBalance(): Observable<any> {
    return this.http.get(this.sharedService.apiUrl('admin/smsBalance')).pipe(
      map(res => {
        return res;
      })
    );
  }

  getCountryCode(): Observable<any> {
    return this.http.get(this.sharedService.apiUrl('admin/countryTelCode')).pipe(
      map(res => {
        return res;
      })
    );
  }
  

  downloadManualFile(name: any): Observable<Blob> {
    const httpOptionsPDF = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      responseType: 'blob' as 'json',
      params: new HttpParams().set('file', name)
    };
    let process$ = this.http.get<any>(this.sharedService.apiUrl('admin/manual'), httpOptionsPDF).pipe(
      map((res: Response) => res), catchError(this.handleError<any>('download file'))
    )
    return process$;

  }

  deleteManualFile (): Observable<Blob> {
    const httpOptions = {
       
    };
    let deleteFile$ = this.http.delete<any>(this.sharedService.apiUrl('admin/manual'), httpOptions)
    return deleteFile$;

  }


 


}



